/**
 * Created by Administrator on 2017/7/6 0006.
 */
import Url from '@/common/js/url.js'
var filter = /\/\?[^\s]*#\//

var login = function (scope) {
  // sessionStorage.removeItem(GLOBAL_CONFIG.TOKEN_NAME);
  var locationUrl = Url.login_url + '?redirect=' + (encodeURIComponent(location.href.replace(filter, '/#/')))
  locationUrl += ('&oauth_scope=' + (scope || 'BASE'))
  console.log(locationUrl)
  // location.href = (locationUrl)
}

export default {
  login: login
}



// WEBPACK FOOTER //
// ./src/common/js/common.js